export enum SignInFlowStartContentFormInputNames {
  /**
   * Required to be `username` for LastPass compatibility
   * @see https://support.lastpass.com/help/how-do-i-configure-my-website-to-work-with-lastpass
   */
  EmailAddress = 'username',
}
